import Phaser from 'phaser';
import { ROSTER } from '../game/stats.ts';
import { generateFxTextures } from '../render/textures.ts';
import { WORLD } from '../world.ts';

/** Loads the bey art, generates the arena + FX textures, then hands off. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    // Simple loading indicator while the bey PNGs stream in.
    const bar = this.add
      .text(WORLD.width / 2, WORLD.height / 2, 'Loading…', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '28px',
        color: '#8aa0c8',
      })
      .setOrigin(0.5);
    this.load.on('progress', (p: number) => bar.setText(`Loading… ${Math.round(p * 100)}%`));

    for (const def of ROSTER) {
      this.load.image(`bey-${def.id}-face`, `assets/beys/${def.id}-face.png`);
      this.load.image(`bey-${def.id}-blur`, `assets/beys/${def.id}-blur.png`);
    }
    this.load.image('arena-dish', 'assets/arena-dish.png');
    this.load.image('arena-bg', 'assets/arena-bg.png');
  }

  create(): void {
    generateFxTextures(this);
    this.scene.start('Title');
  }
}
